(function () {
  const SELECTOR_CUSTOM = '.literie-ready-to-cash-in__reward';
  const SELECTOR_RIVO = '[id^="rivo-reward-"]';

  function wire() {
    const customRewards = document.querySelectorAll(SELECTOR_CUSTOM);
    if (!customRewards.length) return false;

    const rivoRewards = document.querySelectorAll(SELECTOR_RIVO);
    if (!rivoRewards.length) return false;

    let wiredAny = false;

    customRewards.forEach((reward, idx) => {
      if (reward.dataset.literieWired === '1') return;

      const rivoTarget = rivoRewards[idx];
      if (!rivoTarget) return;

      const trigger = (e) => {
        if (reward.tagName === 'A' && reward.getAttribute('href')) return;
        e.preventDefault();
        rivoTarget.click();
      };

      reward.addEventListener('click', trigger);
      reward.addEventListener('keydown', (e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          trigger(e);
        }
      });

      if (reward.tagName !== 'A' && reward.tagName !== 'BUTTON') {
        if (!reward.hasAttribute('role')) reward.setAttribute('role', 'button');
        if (!reward.hasAttribute('tabindex')) reward.setAttribute('tabindex', '0');
      }

      reward.dataset.literieWired = '1';
      wiredAny = true;
    });

    return wiredAny;
  }

  function init() {
    if (wire()) return;

    const observer = new MutationObserver(() => {
      if (wire()) observer.disconnect();
    });
    observer.observe(document.body, { childList: true, subtree: true });
    setTimeout(() => observer.disconnect(), 15000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
